//正则校验
export function isName(rule, value, callback) { //可包含汉字大小写英文和数字
    var pattern = /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4E00-\u9FA5]+$/;
    if (value && (!(pattern).test(value))) {
        callback(new Error('名称不能有特殊符号'))
    } else {
        callback()
    }
}
export function isChinese(rule, value, callback) { //只能中文
    var pattern = /^[u4E00-\u9FA5]/;
    if (value && (!(pattern).test(value))) {
        callback(new Error('城市名称不正确'))
    } else {
        callback()
    }
}
export function isPhone(rule, value, callback) { //手机号码    
    var pattern = /^1[3456789]\d{9}$/;
    if (pattern.test(value)) {
        return callback()
    }
    return callback('联系电话不正确');
}
export function isIdNo(rule, value, callback) { //身份证号码校验
    var pattern = /^\d{17}[\d|x|X]/;

    if (pattern.test(value)) {
        return callback()
    }
    return callback('身份证号有误');
}
export function isImg(type) { // 图片校验
    type = (type || "").toUpperCase();
    if (type == ".JPG" || type == ".JPEG" || type == ".BMP" || type == ".PNG" || type == '.GIF') {
        return true;
    }
    return false;
}
export function isVideo(type) { // 视频格式校验
    type = (type || "").toUpperCase();
    if (type == "MP4" || type == "WMA" || type == 'MOV') {
        return true;
    }
    return false;
}
export function isAudio(type) { // 视频格式校验
    type = (type || "").toUpperCase();
    if (type == "MP3" || type == "MPEG" || type == "MPEG-4" || type == "MIDI" || type == "WMA" || type == "WAV") {
        return true;
    }
    return false;
}

(function($) {
    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
        return Math.floor(obj) === obj
    }

    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    function toInteger(floatNum) {
        var ret = {
            times: 1,
            num: 0
        }
        if (isInteger(floatNum)) {
            ret.num = floatNum
            return ret
        }
        var strfi = floatNum + ''
        var dotPos = strfi.indexOf('.')
        var len = strfi.substr(dotPos + 1).length + 1
        var times = Math.pow(10, len)
        var p = parseInt(floatNum);
        var delta = 0.5;
        if (p < 0) {
            delta = -0.5;
        }
        var intNum = parseInt(floatNum * times + delta, 10)
        ret.times = times
        ret.num = intNum
        return ret
    }
    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    function operation(a, b, op, digits) {
        var _nd = /^[0-9]$/.test(digits)
        if (_nd) {
            digits = Math.floor(digits)
        }
        var o1 = toInteger(a)
        var o2 = toInteger(b)
        var n1 = o1.num
        var n2 = o2.num
        var t1 = o1.times
        var t2 = o2.times
        var max = t1 > t2 ? t1 : t2
        var result = null
        switch (op) {
            case 'add':
                if (t1 === t2) { // 两个小数位数相同
                    result = n1 + n2
                } else if (t1 > t2) { // o1 小数位 大于 o2
                    result = n1 + n2 * (t1 / t2)
                } else { // o1 小数位 小于 o2
                    result = n1 * (t2 / t1) + n2
                }
                if (_nd) {
                    return parseFloat((result / max).toFixed(digits))
                }
                return result / max
            case 'subtract':
                if (t1 === t2) {
                    result = n1 - n2
                } else if (t1 > t2) {
                    result = n1 - n2 * (t1 / t2)
                } else {
                    result = n1 * (t2 / t1) - n2
                }
                if (_nd) {
                    return parseFloat((result / max).toFixed(digits))
                }
                return result / max
            case 'multiply':
                result = (n1 * n2) / (t1 * t2)
                if (_nd) {
                    return parseFloat(result.toFixed(digits))
                }
                return result
            case 'divide':
                result = function() {
                    var r1 = n1 / n2
                    var r2 = t2 / t1
                    return operation(r1, r2, 'multiply')
                }();
                if (_nd) {
                    return parseFloat(result.toFixed(digits))
                }
                return result
        }
    }

    // 加减乘除的四个接口
    function add(a, b, digits) {
        return operation(a, b, 'add', digits)
    }

    function subtract(a, b, digits) {
        return operation(a, b, 'subtract', digits)
    }

    function multiply(a, b, digits) {
        return operation(a, b, 'multiply', digits)
    }

    function divide(a, b, digits) {
        return operation(a, b, 'divide', digits)
    }


    $.add = add;
    $.subtract = subtract;
    $.multiply = multiply;
    $.divide = divide;

})($);


// WEBPACK FOOTER //
// ./src/utils/rules.js